export default {"src":"/_next/static/media/tab-calendar-active.20143391.svg","height":40,"width":41};